export default function getFullPageRelativeTop(
  element: HTMLElement | null
): number {
  let top = 0;
  let elementAssign = element;

  while (elementAssign) {
    top += elementAssign.offsetTop;

    elementAssign = elementAssign.offsetParent as HTMLElement | null;
  }

  return top;
}
